import React, { useState } from "react";
import FormPopover from "./FormPopover";

interface JustificationPopoverProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (justification: string) => void;
  isLoading: boolean;
  align?: "left" | "right";
}

const JustificationPopover: React.FC<JustificationPopoverProps> = ({
  show,
  onClose,
  onSubmit,
  isLoading,
  align = "left",
}) => {
  const [justification, setJustification] = useState("");

  const handleClose = () => {
    setJustification("");
    onClose();
  };

  const handleSubmit = () => {
    if (!justification.trim()) return;
    onSubmit(justification);
    setJustification("");
  };

  return (
    <FormPopover
      show={show}
      onClose={handleClose}
      title="Override Justification Required"
      description="AI did not match this candidate. Please provide justification for overriding."
      align={align}
      submitLabel="Override & Approve"
      submitLoadingLabel="Updating..."
      submitColor="#10b981"
      canSubmit={!!justification.trim()}
      isLoading={isLoading}
      onSubmit={handleSubmit}
    >
      <textarea
        value={justification}
        onChange={(e) => setJustification(e.target.value)}
        placeholder="Why should this candidate be approved despite AI not matching?"
        rows={3}
        style={{
          width: "100%",
          padding: "6px 8px",
          borderRadius: "4px",
          border: "1px solid #d1d5db",
          fontSize: "12px",
          marginBottom: "8px",
          resize: "vertical",
        }}
      />
    </FormPopover>
  );
};

export default JustificationPopover;
